function resolveTeamCode(event, match) {
    if (event.team_code) return event.team_code
    if (!match) return ''
    if (event.team_id != null && event.team_id !== '') {
        if (String(event.team_id) === String(match.home_team_id)) return match.home_team_code || ''
        if (String(event.team_id) === String(match.away_team_id)) return match.away_team_code || ''
    }
    if (event.place === 'home') return match.home_team_code || ''
    if (event.place === 'away') return match.away_team_code || ''
    return ''
}

function resolveTeamId(event, match) {
    if (event.team_id != null && event.team_id !== '') return String(event.team_id)
    if (!match) return ''
    const teamCode = resolveTeamCode(event, match)
    if (teamCode === match.home_team_code) {
        return match.home_team_id != null && match.home_team_id !== '' ? String(match.home_team_id) : ''
    }
    if (teamCode === match.away_team_code) {
        return match.away_team_id != null && match.away_team_id !== '' ? String(match.away_team_id) : ''
    }
    return ''
}

export function resolveTeamIdFromForm(form, match) {
    if (!form) return ''
    if (!match) {
        return form.team_id != null && form.team_id !== '' ? String(form.team_id) : ''
    }
    if (form.team_code === match.home_team_code) {
        return match.home_team_id != null && match.home_team_id !== '' ? String(match.home_team_id) : ''
    }
    if (form.team_code === match.away_team_code) {
        return match.away_team_id != null && match.away_team_id !== '' ? String(match.away_team_id) : ''
    }
    if (form.place === 'home') {
        return match.home_team_id != null && match.home_team_id !== '' ? String(match.home_team_id) : ''
    }
    if (form.place === 'away') {
        return match.away_team_id != null && match.away_team_id !== '' ? String(match.away_team_id) : ''
    }
    if (form.team_id != null && form.team_id !== '') {
        const teamId = String(form.team_id)
        if (teamId === String(match.home_team_id) || teamId === String(match.away_team_id)) {
            return teamId
        }
    }
    return ''
}

export function mapEventToLiveblogForm(event, match = null) {
    if (!event) return null

    const minute = (event.event_minute || '').toString().replace(/'/g, '')

    const sportEventId =
        event.event_id != null && event.event_id !== '' ? String(event.event_id) : ''
    const providerEventId =
        event.provider_event_id != null && event.provider_event_id !== ''
            ? String(event.provider_event_id)
            : sportEventId

    return {
        content_type: 'event',
        provider_event_id: providerEventId,
        provider: event.provider || '',
        title: event.title || '',
        body: event.body || '',
        payload: null,
        event_type_id: event.event_type_id != null && event.event_type_id !== '' ? String(event.event_type_id) : '',
        event_type_name: event.event_type_name || '',
        event_reason_id: event.event_reason_id != null && event.event_reason_id !== '' ? String(event.event_reason_id) : '',
        period_id: event.period_id != null && event.period_id !== '' ? String(event.period_id) : '',
        period_name: event.period_name || '',
        comment: event.comment || '',
        event_minute: minute,
        place: event.place || '',
        team_code: resolveTeamCode(event, match),
        team_id: resolveTeamId(event, match),
        player_id: event.player_id != null && event.player_id !== '' ? String(event.player_id) : '',
        player_name: event.player_name || '',
        related_player_id:
            event.related_player_id != null && event.related_player_id !== '' ? String(event.related_player_id) : '',
        related_player_name: event.related_player_name || '',
        event_reason_name: event.event_reason_name || '',
        home_goals: event.home_goals ?? match?.score_home ?? '',
        away_goals: event.away_goals ?? match?.score_away ?? '',
        image_file: null,
        gallery_items: null,
    }
}